import React from 'react';

import BufferOptions from 'buffers/BufferOptions';
import {Molecule} from 'chemistry/molecules/tabs/MoleculeFileState';
import {ConnectedMoleculePhysicochemicalProperties} from 'chemistry/molecules/tabs/MoleculePhysicochemicalProperties';
import DataConnector from 'connect/DataConnector';

export interface ConnectedMoleculePhysicochemicalPropertiesTabProps {
  moleculeVersionId: string;
}

export interface UnconnectedMoleculePhysicochemicalPropertiesTabProps {
  moleculeId: string;
  molecule: Molecule;
}

export type MoleculePhysicochemicalPropertiesTabProps = ConnectedMoleculePhysicochemicalPropertiesTabProps &
  UnconnectedMoleculePhysicochemicalPropertiesTabProps;

// Subscribing to moleculeVersionId (even though it's unused below) ensures this component
// re-renders -- and therefore re-reads molecule.getVersionBannerText() -- when the version changes
// while this tab is already open, rather than only picking up the new banner on the next mount.
class MoleculePhysicochemicalPropertiesTabConnector extends DataConnector<
  UnconnectedMoleculePhysicochemicalPropertiesTabProps,
  ConnectedMoleculePhysicochemicalPropertiesTabProps
> {
  enhanceProps(): ConnectedMoleculePhysicochemicalPropertiesTabProps {
    const moleculeVersionId =
      this.reduxState().ui.chemistry.moleculeVersionUIs[this.props.moleculeId].moleculeVersionId;
    return {moleculeVersionId};
  }
}

function MoleculePhysicochemicalPropertiesTab({
  moleculeId,
  molecule,
}: MoleculePhysicochemicalPropertiesTabProps): JSX.Element {
  return (
    <div className="physicochemical-properties-tab">
      {molecule.getVersionBannerText() != null && <BufferOptions banner={molecule.getVersionBannerText()} />}
      <div className="react-tab-container">
        <ConnectedMoleculePhysicochemicalProperties moleculeId={moleculeId} />
      </div>
    </div>
  );
}

const ConnectedMoleculePhysicochemicalPropertiesTab = MoleculePhysicochemicalPropertiesTabConnector.connect(
  MoleculePhysicochemicalPropertiesTab
);
export default ConnectedMoleculePhysicochemicalPropertiesTab;
